import type { AttendanceStatus } from '@aegislab/shared';
import { formatDurationCompact, formatTimeShort } from '../../../../shared/lib';
import { getAttendanceStatusLabel } from '../../model/status';
import { srOnly } from '@/shared/ui/styles';
import * as s from './TeamAttendanceTable.css';

interface TeamMemberAttendance {
  userId: string;
  name: string;
  status: AttendanceStatus;
  clockInAt: string | null;
  clockOutAt: string | null;
  totalWorkDurationMs: number;
}

interface TeamAttendanceTableProps {
  members: TeamMemberAttendance[];
}

function getStatusDotClass(status: AttendanceStatus): string {
  switch (status) {
    case 'CLOCKED_IN':
      return s.statusDotGreen;
    case 'ON_BREAK':
      return s.statusDotAmber;
    case 'CLOCKED_OUT':
    case 'ABSENT':
    default:
      // 비활성/종료 상태는 회색 점 — 기존 default 폴백 유지
      return s.statusDotGray;
  }
}

export function TeamAttendanceTable({ members }: TeamAttendanceTableProps) {
  return (
    <div className={s.wrapper}>
      <table className={s.table}>
        <caption className={srOnly}>팀 멤버 근무 현황</caption>
        <thead>
          <tr>
            <th scope="col" className={s.th}>
              이름
            </th>
            <th scope="col" className={s.th}>
              상태
            </th>
            <th scope="col" className={s.th}>
              출근시간
            </th>
            <th scope="col" className={s.th}>
              근무시간
            </th>
          </tr>
        </thead>
        <tbody>
          {members.map((member) => (
            <tr key={member.userId} className={s.tr}>
              <td className={s.td}>{member.name}</td>
              <td className={s.td}>
                <span className={s.statusContainer}>
                  <span className={getStatusDotClass(member.status)} />
                  {getAttendanceStatusLabel(member.status)}
                </span>
              </td>
              <td className={s.td}>{formatTimeShort(member.clockInAt)}</td>
              <td className={s.td}>{formatDurationCompact(member.totalWorkDurationMs)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
